import React, { useState } from 'react';
import styles from './MobileSearchbar.module.css';
import SearchTechniques from '@src/components/Base/Header/HeaderSearchTechniques';

const MobileSearchbar = () => {
  const [query, setQuery] = useState('');
  const [show, setShow] = useState(false);

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query === undefined || query === null || query === '') {
      window.location.href = `/search?q=""`;
    } else {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  };

  const openTechniques = () => {
    setShow(true);
  };

  const handleClick = () => {
    setShow(!show);
  };

  return (
    <header className={styles.mobileSearchbar}>
      <div
        className={styles.searchbarContanier}
        style={{
          zIndex: show === true ? '1042' : '0',
          borderBottom: show === true ? 'none' : '0.5px solid #ccc',
        }}
      >
        <form onSubmit={handleSubmit} action='search'>
          <button type='submit' className={styles.searchbarBtn}>
            <img className={styles.searchIcon} src='../../../search.svg' alt='search' />
          </button>
          <input
            type='search'
            name='q'
            className={styles.searchbar}
            placeholder='사건번호, 키워드, 법령 등을 검색해 보세요'
            // value={value}
            onChange={handleChange}
            onClick={openTechniques}
            autoComplete='off'
          />
        </form>
        <SearchTechniques show={show} onClick={handleClick} />
      </div>
      <div
        className={styles.techniquesListOpen}
        style={{
          display: show ? 'block' : 'none',
          zIndex: show ? '1041' : 'none',
          opacity: show ? '0.5' : '0',
        }}
        onClick={handleClick}
      ></div>
    </header>
  );
};

export default MobileSearchbar;
